export default {
      id: "oc-caret-down-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-caret-down",
      toString: function () {
        return this.url;
      }
    }